import { type RecordLinkAttributes } from './generated/RecordLinkAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface RecordLink extends RecordLinkAttributes {}

@model
class RecordLink extends ApplicationModel {
  // Start auto-generated
  static typename: 'RecordLink' = 'RecordLink';
  get typename(): 'RecordLink' {
    return 'RecordLink';
  }

  static internalTypename: 'RecordLink' = 'RecordLink';
  get internalTypename(): 'RecordLink' {
    return 'RecordLink';
  }

  static inputType = 'RecordLinkAttributes!';

  static fields = {
    annotationId: attr({ readable: true }),
    childRecordId: attr({ readable: true }),
    childRecordType: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    inverted: attr({ readable: true }),
    linkType: attr({ writable: true, readable: true }),
    parentRecordId: attr({ readable: true }),
    parentRecordType: attr({ readable: true }),
    relationDescription: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    annotation: attr.belongsTo({
      writeShape: [
        'id',
        'type',
        'resolved',
        'configuration',
        'annotatable',
        'tags',
      ],
      readable: true,
      typename: 'Annotation',
    }),
    childRecord: attr.belongsTo({
      writeShape: ['id', 'type'],
      readable: true,
      typename: [
        'Epic',
        'Feature',
        'Goal',
        'Idea',
        'Initiative',
        'KeyResult',
        'PdlcStep',
        'ReleasePhase',
        'Requirement',
      ],
    }),
    parentRecord: attr.belongsTo({
      writeShape: ['id', 'type'],
      readable: true,
      typename: [
        'Epic',
        'Feature',
        'Goal',
        'Idea',
        'Initiative',
        'KeyResult',
        'PdlcStep',
        'ReleasePhase',
        'Requirement',
      ],
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated
}

export default RecordLink;
